import React from "react";
import { NotionRenderer } from "react-notion";

import "react-notion/src/styles.css";
import "prismjs/themes/prism-tomorrow.css";

const ROOT_PAGE_ID = "041db4e9b36e41ac93f8b12ada576964";
const API_BASE = "https://notion-api.splitbee.io/v1/page/";

export const toNotionImageUrl = (url, block) => {
  let notionUrl = url;

  if (!url.startsWith("https://www.notion.so")) {
    notionUrl = "https://www.notion.so".concat(
      url.startsWith("/image") ? url : `/image/${encodeURIComponent(url)}`
    );
  }

  const imageUrl = new URL(notionUrl);

  if (block) {
    const table = ["space", "team"].includes(block.value.parent_table)
      ? "block"
      : block.value.parent_table;
    imageUrl.searchParams.set("table", table);
    imageUrl.searchParams.set("id", block.value.id);
    imageUrl.searchParams.set("cache", "v2");
  }

  return imageUrl.toString();
};

// Splitbee's API now returns {[id]: {value: {value: {...}, role}, spaceId}}
// but react-notion expects {[id]: {value: {...}}}.
function unwrapBlock(raw) {
  if (raw?.value?.value) return { value: raw.value.value };
  return raw;
}

function flattenBlockMap(rawData) {
  const result = {};
  for (const [id, block] of Object.entries(rawData)) {
    result[id] = unwrapBlock(block);
  }
  return result;
}

function findMissingChildren(blockMap) {
  const referenced = new Set();
  for (const block of Object.values(blockMap)) {
    const content = block?.value?.content;
    if (Array.isArray(content)) {
      for (const id of content) referenced.add(id);
    }
  }
  return [...referenced].filter((id) => !blockMap[id]);
}

async function fetchBlock(id) {
  const stripped = id.replace(/-/g, "");
  const res = await fetch(API_BASE + stripped);
  return res.json();
}

async function fetchFullBlockMap(rootId, maxRounds = 5) {
  let blockMap = flattenBlockMap(await fetchBlock(rootId));

  for (let round = 0; round < maxRounds; round++) {
    const missing = findMissingChildren(blockMap);
    if (missing.length === 0) break;

    const results = await Promise.all(missing.map((id) => fetchBlock(id).catch(() => ({}))));
    for (const raw of results) {
      for (const [id, block] of Object.entries(raw)) {
        if (!blockMap[id]) blockMap[id] = unwrapBlock(block);
      }
    }
  }

  return blockMap;
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      blockMap: {},
    };
  }

  async componentDidMount() {
    const blockMap = await fetchFullBlockMap(ROOT_PAGE_ID);
    this.setState({ blockMap });
  }

  render() {
    return (
      <div>
        <NotionRenderer
          fullPage
          blockMap={this.state.blockMap}
          mapImageUrl={toNotionImageUrl}
        />
      </div>
    );
  }
}

export default App;
